<!--SKU编辑  -->
<template>
	<div>
		<el-dialog title="配置价格方案" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="700px" :before-close="cancle">
			<div class="form-box">
				<el-table
					ref="table"
					:data="tableData"
					:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}"
					border @selection-change="handleSelectionChange"
					style="width: 100%">
					<el-table-column type="selection" width="55">
					</el-table-column>
					<el-table-column prop="priceName" label="名称">
					</el-table-column>
					<el-table-column prop="priorityLevel" label="优先">
					</el-table-column>
					<el-table-column prop="startDate" label="生效日期">
					</el-table-column>
					<el-table-column prop="endDate" label="终止日期">
					</el-table-column>
					<el-table-column prop="remark" label="备注">
					</el-table-column>
				</el-table>

			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="cancle()">取 消</el-button>
				<el-button size="small" type="primary" @click="submitForm()">确 定</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import groupTree from '@/components/groupTree/index.vue';
	export default {
		components: {
			groupTree
		},
		data() {
			return {
				dialogVisible: false,
				tableData: [],
				multipleSelection: [],
				selectList: [],
			}
		},
		created() {

		},
		methods: {
			init(data) {
				this.$nextTick(() => {
					this.dialogVisible = true
					this.getPriceInfo()
					if (data) {
						this.selectList = data.split(",")
						if (this.selectList.length > 0) {
							setTimeout(() => {
								this.tableData.forEach(item => {
									this.selectList.forEach(ele => {
										if (item.priceId == ele) {
											this.$refs.table.toggleRowSelection(item, true)
											this.$forceUpdate()
										}
									});
								});
							}, 500)

						}
					}


				})
			},
			//  获取价格列表
			getPriceInfo() {
				let that = this;
				that.$request.post(
						"getPriceList",
						false, {
							status: 0
						}
					)
					.then((res) => {
						if (res) {
							that.tableData = res.data
						} else {
							that.$message.error(res.msg);
						}
					})
			},
			// 列多选
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},

			// 保存
			submitForm() {
				let that = this;
				if (that.multipleSelection.length <= 0) {
					that.$message.error('请先选择!');
					return
				}
				this.dialogVisible = false
				that.$emit("getPriceList", that.multipleSelection)
			},
			// 取消
			cancle() {
				this.dialogVisible = false
				// this.multipleSelection = []
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.width100 {
		width: 440px;
	}

	.form-text {
		color: #606266;
	}

	.w190 {
		width: 160px !important;
	}

	.block {
		/deep/ .el-form--inline .el-form-item__content {
			display: block;
		}

	}

</style>
